import { actionTypes as storeActionTypes } from 'status/partial/store';

const saveStoreToSession = store => next => (action) => {
  const result = next(action);
  const state = store.getState();
  switch (action.type) {
    case storeActionTypes.SAVE_STORE:
      localStorage.setItem('store', JSON.stringify(state.store));
      break;
    case storeActionTypes.REMOVE_STORE:
      localStorage.removeItem('store');
      break;
    default:
      break;
  }
  return result;
};

export default saveStoreToSession;
